import { useMemo } from 'react';
import { useListSegments, useGetAudience } from '@frontend/api-bulk-messaging';
import { useAppScopeStore } from '@frontend/scope';
import { useAudienceTray } from '../providers/audience-tray-provider';

export const useSegmentsView = () => {
  const { selectedOrgId: orgId } = useAppScopeStore();
  const { campaignId, enableManualSelection } = useAudienceTray();

  const { data: segments = [] } = useListSegments({ campaignId, orgId }, { enabled: !enableManualSelection });

  const { data: audience } = useGetAudience({ campaignId, orgId }, { enabled: !enableManualSelection });

  const segmentsRecipientsCount = useMemo(() => {
    if (enableManualSelection) return 0;
    // Remove segments with lists because they are calculated as part of selectedListsRecipientsCount from useListsView
    return segments.filter((list) => !list.listId).reduce((acc, segment) => acc + (segment.recipientCount ?? 0), 0);
  }, [enableManualSelection, segments]);

  if (enableManualSelection) {
    return {
      duplicateRecipientsCount: 0,
      segments: [],
      segmentsRecipientsCount: 0,
    };
  }

  return {
    duplicateRecipientsCount: audience?.duplicateRecipientCount ?? 0,
    segments,
    segmentsRecipientsCount,
  };
};
